import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { LayoutService } from 'src/app/core/services/layout.service';
import { localDB } from 'src/app/shared/helpers/localStorage';
import { SplashScreenService } from '../services/splash-screen.service';
import { ThemeService } from '../services/theme.service';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { initGetBG, initGetColor } from 'src/app/modules/my-board/options-board';
import { PreferencesService } from 'src/app/modules/my-board/service/preferences-service.service';
import { SafariBannerComponent } from './components/safari-banner/safari-banner.component';
import { MatProgressBar, MatProgressBarModule } from '@angular/material/progress-bar';
import { RevisionBannerComponent } from './components/revision-banner/revision-banner.component';
import { ToastGroupComponent } from 'src/app/shared/components/toast-alert/toastGroup/toast-group.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { AsyncPipe, CommonModule } from '@angular/common';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { groupBy } from 'src/app/shared/helpers/groupBy';
import { configurations } from 'src/app/shared/interfaces/configurations.interface';
import { DashboardService } from 'src/app/modules/indicators/services/dashboard.service';
import { ToasService } from 'src/app/shared/components/toast-alert/service/toas-service.service';
import { setToTitleCase } from 'src/app/shared/helpers/transformText';
import { ToastResponse } from 'src/app/shared/components/toast-alert/toast.config';
import { encriptar } from 'src/app/shared/helpers/encryption';
import { environment as env } from 'src/environments/environment';
import { WebSocktesService } from 'src/app/shared/services/webSockets.service';

@Component({
  selector: 'mg-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: true,
  imports: [SafariBannerComponent, ToolbarComponent, AsyncPipe, MatProgressBar, RevisionBannerComponent, MatSidenavModule, ToastGroupComponent, RouterOutlet, SidenavComponent, MatProgressBarModule, CommonModule]
})
export class LayoutComponent implements OnInit, AfterViewInit {
  loading: boolean = false;
  isDesktop$ = this._layoutService.isScreenXL$;
  sidenavCollapsed$ = this._layoutService.sidenavCollapsed$;
  @ViewChild('sidenav') sidenav: MatSidenav;
  slug: any;
  
  constructor(
    private readonly _layoutService: LayoutService,
    private readonly _router: Router,
    private readonly _splashScreenService: SplashScreenService,
    private readonly _themeService: ThemeService,
    private readonly route: ActivatedRoute,
    private readonly _activeRoute: ActivatedRoute,
    private readonly _preferencesService: PreferencesService,
    private readonly _dashboardService: DashboardService,
    private readonly _toastService: ToasService,
    private readonly _webSocketsService: WebSocktesService
  ) {
    this._activeRoute.data.subscribe(route => {
      const configPreferences = route['preferences'][1];
      if (configPreferences) {
        localDB.setItem("holidays", JSON.stringify(configPreferences.FERIADOS));
        localDB.setItem("permissions", JSON.stringify(configPreferences.SOLICTID_POR_DIAS[0].sCodigo));
      }
      if (route['preferences'][0]?.isSuccess && route['preferences'][0].data) {
        this._preferencesService.preferencesSubject.next(route['preferences']);
      }
      this._preferencesService.$preferencesObs.subscribe({
        next: (resp: any) => {
          if (resp[0].isSuccess) {
            resp[0].data.oTheme = initGetColor(resp[0].data.oColorBackground.sColor);
            resp[0].data.oBackground_Theme = initGetBG(resp[0].data.oColorBackground.sFondo);
            localDB.setItem('preferences', JSON.stringify(resp[0].data));
            if (resp[1]['HORARIO_LABORAL']) {
              let hr: { nDia: number, Intervals: any }[] = [];
              resp[1]['HORARIO_LABORAL'].map((x: configurations) => {
                let intervals = JSON.parse(x.sDescripcion);
                hr.push({
                  nDia: Number(x.sCodigo),
                  Intervals: groupBy(intervals, (i: any) => i.nIntervalo)
                });
              });
              localDB.setItem('schedule', JSON.stringify(hr));
            }
            localDB.setItem('preferences', JSON.stringify(resp[0].data));
          }
        }
      });
    });
    this._splashScreenService.hide();
    this.listiningRouteChange();
  }

  ngOnInit(): void {
    this._webSocketsService.initAllConnections();
    this.route.data.subscribe(data => {
      const [configs] = data['preferences'];
      if (configs?.['AREA-LISTADO']) {
        localDB.setItem("AREAS_LIST", JSON.stringify(configs['AREA-LISTADO']));
      }
    });
  }

  ngAfterViewInit(): void {
    this.getConfig();
    this.GetNotifyProjecStatus()
  }

  // handleIndexDBBySocketsEvents(){
  //  //SOLICITUDES
  //   let requestData: HubData = {
  //     hubUrl: SOCKETS_URLS.REQUEST,
  //     events: [SOCKETS_EVENTS.CREATE, SOCKETS_EVENTS.UPDATE, SOCKETS_EVENTS.DELETE, SOCKETS_EVENTS.MANTEINER],
  //     connectionData: null,
  //     BehaviorData:{
  //      oldData: null,
  //       sId_Name: 'nId_Solicitud'
  //     }
  //   } 
  //    // ...AGREGAR OTROS MÓDULOS


  //   // this._requestService.getLastRequest.subscribe(resp =>{
  //   //   if(resp.message == 'init'){
  //   //     this._requestService.requestLastRequest().subscribe()
  //   //   }
  //   //   requestData.BehaviorData!.oldData = resp
  //   // })
  //   this._webSocketsService.getHubDataConnections().subscribe({
  //     next: (connection) => {
  //       //SOLICITUDES
  //       requestData.connectionData = connection
  //       this._webSocketsService.handlHubEventsOnBehaviorS(requestData)
  //       //this._webSocketsService.handleHubEventsOnIndexedDB(requestData)

  //       // ...AGREGAR OTROS MÓDULOS
  //     }
  //   })
  // }

  getConfig() {
    let themeSelected = JSON.parse(localDB.getItem('preferences')).oTheme;
    let bgSelected = JSON.parse(
      localDB.getItem('preferences')
    ).oBackground_Theme;
    if (bgSelected) {
      let myElement = document.getElementById('contentBg');
      if (myElement != null) {
        myElement.style.backgroundImage = `url('${bgSelected.jBackgrounds?.url}')`;
      }
    }
    this._themeService.setTheme(themeSelected!.jColors);
  }

  // getFilterTask(){
  //   if(this._accessService.validarPermisoSlug('TEAM-HAVE-SUBORDINATE')){
  //     this._taskService.pryRqFilterData.subscribe(response =>{})
  //   }
  // }


  listiningRouteChange() {
    this._router.events.subscribe((event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  clickItem() {
    this.isDesktop$.subscribe((x) => {
      if (!x) {
        this.sidenav.toggle();
      }
    });
  }

  // TOAST PROYECTOS
  GetNotifyProjecStatus() {
    this._dashboardService.pryRqdata.subscribe({
      next: (val: any) => {
        if (val?.isSuccess) {
          let totalToast: number = 0
          val.data.map((item: any, index: number) => {
            totalToast++
            this.callToast(item/*, timerUp*/)
            // }else{
            //   this.callToast(item)
            // }
          });
        }
      },
      error: (err) => {
        console.log(err)
      }
    });
  }

  callToast(item: any, timerUp?: number) {
    this._toastService
      .init({
        type: 'warning',
        message: `El requerimiento <strong> ${setToTitleCase(item.sRequerimiento)} </strong> del proyecto 
      <strong> ${setToTitleCase(item.sProyecto)} </strong> tiene horas sobrepasadas `,
        labelCheck: 'No volver a mostrar',
        timer: 20 //timerUp ?  20 + timerUp : 20,
      })
      .subscribe({
        next: (params: ToastResponse) => {
          if (params.isChecked) {
            let idProyecto = item.nId_Proyecto;
            let idRequerimiento = item.nId_Requerimiento;

            this._dashboardService
              .updatestatusnotification(idProyecto, idRequerimiento)
              .toPromise();
          }
          if (params.confirmRedirection) {
            let query =
              'nId_Requerimiento=' + item.nId_Requerimiento;
            let queryParams = query.split('&');
            let url = 'proyectos-requerimientos/lista';
            let newQueryParams: any = new Object();
            queryParams.forEach((param: string) => {
              let [key, value] = param.split('=');
              newQueryParams[encriptar(env.securityKey, key)] =
                encriptar(env.securityKey, value);
            });
            this._router.navigate([url], { queryParams: newQueryParams });
          }
        },
      });
  }
}